<script lang="ts">
	import IconButton from '../../buttons/IconButton.svelte';
	import { _ } from 'svelte-i18n';
	import { FilterCondition } from '../../../types/ListTypes';

	interface Props {
		filterCondition?: FilterCondition;
		onFilterTypeChange: () => void;
	}

	let { filterCondition = $bindable(FilterCondition.EQ), onFilterTypeChange }: Props = $props();

	function getIconNameForFilterType(filterType: FilterCondition): string {
		if (filterType == FilterCondition.EQ) {
			return 'equals';
		} else if (filterType == FilterCondition.LE) {
			return 'less-than-equal';
		} else if (filterType == FilterCondition.L) {
			return 'less-than';
		} else if (filterType == FilterCondition.G) {
			return 'greater-than';
		} else if (filterType == FilterCondition.GE) {
			return 'greater-than-equal';
		} else return 'none';
	}

	let options = [
		FilterCondition.EQ,
		FilterCondition.LE,
		FilterCondition.L,
		FilterCondition.G,
		FilterCondition.GE
	];
	let iconName = $derived(getIconNameForFilterType(filterCondition));

	function swapType() {
		//Get the index
		let index = options.findIndex((type) => type == filterCondition);
		//Set the new index
		if (index < options.length - 1) {
			index++;
		} else {
			index = 0;
		}

		filterCondition = options[index];
		onFilterTypeChange();
	}
</script>

<div class="rounded-full">
	<IconButton
		size={'small'}
		hoverText={$_(`basic_components.filter_types.${iconName}`)}
		bind:iconName
		onClick={swapType}
	/>
</div>
